import React from 'react';
import { Link } from 'react-router-dom';
import { WidgetCard } from '../ui/WidgetCard';
import { currentUser } from '../../data/currentUser';
export function ProfileWidget() {
  return <WidgetCard title="Public Profile" data-id="element-69">
      <div className="space-y-4" data-id="element-70">
        <div className="flex flex-col items-center" data-id="element-71">
          <div className="h-16 w-16 rounded-full overflow-hidden mb-3" data-id="element-72">
            <img src={currentUser.image} alt={currentUser.name} className="h-full w-full object-cover" data-id="element-73" />
          </div>
          <div className="text-base font-medium text-gray-900" data-id="element-74">
            @{currentUser.username}
          </div>
          <div className="text-sm text-gray-500 mt-1" data-id="element-75">
            Your public page is active
          </div>
        </div>
        <Link to="/profile" className="w-full py-2.5 bg-[#C6D6AB] text-gray-800 rounded-md text-sm font-medium flex items-center justify-center hover:bg-[#b8c99a] transition-colors" data-id="element-76">
          <span data-id="element-77">View Profile</span>
        </Link>
        <button className="w-full py-2.5 border border-[#7F9EA4] text-[#376770] rounded-md text-sm font-medium flex items-center justify-center hover:bg-[#EFF2F1] transition-colors" data-id="element-78">
          <span data-id="element-79">Manage Page</span>
        </button>
      </div>
    </WidgetCard>;
}